import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=81f48ea8&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=81f48ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f48ea8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuList: require('/home/bitrix/frontend/components/sidebars/MenuAside/MenuList.vue').default})
